import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { toast } from 'react-toastify'
import { useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { colors } from '~constants/colorsPallete'

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
}

export default function ModalCobrar({
  open,
  handleClose,
  selectedIds,
  onConfirm,
}: {
  open: boolean
  handleClose: VoidFunction
  selectedIds: string[]
  onConfirm?: (ids: string[]) => Promise<void>
}) {
  const [loading, setLoading] = useState(false)

  const handleConfirmCobrar = async () => {
    setLoading(true)
    try {
      if (onConfirm) {
        await onConfirm(selectedIds)
      }

      toast.success(`${selectedIds.length} nota(s) fiscal(is) solicitada(s) com sucesso!`)
      handleClose()
    } catch (error) {
      console.error('Error recovering invoices:', error)
      toast.error('Erro ao solicitar cobrança. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-cobrar-title"
      aria-describedby="modal-cobrar-description"
    >
      <Box sx={style}>
        <Typography id="modal-cobrar-title" variant="h6" component="h2">
          Confirmar Cobrança
        </Typography>
        <Typography id="modal-cobrar-description" sx={{ mt: 2 }}>
          Você tem certeza que deseja solicitar a cobrança de <strong>{selectedIds.length}</strong> nota(s) fiscal(is)?
        </Typography>
        <Typography sx={{ mt: 1, fontSize: '0.875rem', color: 'text.secondary' }}>
          Esta ação enviará uma solicitação de cobrança para as notas fiscais selecionadas através de emails. Podendo
          demorar alguns minutos para que os destinatários recebam as notificações.
        </Typography>
        <div
          style={{
            marginTop: '20px',
            justifyContent: 'flex-end',
            display: 'flex',
          }}
        >
          <Button onClick={handleClose} sx={{ mr: 2, color: colors['gray.500'] }} disabled={loading}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmCobrar}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            sx={{
              backgroundColor: colors['green.default'],
              '&:hover': {
                backgroundColor: colors['green.600'],
              },
            }}
          >
            {loading ? 'Enviando...' : 'Confirmar Cobrança'}
          </Button>
        </div>
      </Box>
    </Modal>
  )
}
